(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  /* MARCA | 28/09/2026 | Keep the page in the Miss Fragrance light theme only while the cart holds just Miss Fragrance products */
  document.addEventListener('cart:updated', () => {
    const missCartState = document.querySelector('#main-cart-items [data-miss-fragrance-cart]');
    if (!missCartState) return;

    document.body.classList.toggle('theme-miss-fragrance', missCartState.dataset.missFragranceCart === 'true');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-daily-limit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('promo-daily-limit')) {
    class PromoDailyLimit extends HTMLElement {
      connectedCallback() {
        this.limit = Math.max(2, parseInt(this.dataset.limit, 10) || 100);
        this.start = Math.max(0, parseInt(this.dataset.start, 10) || 5);
        this.maxSold = this.limit - 1;
        this.soldEl = this.querySelector('[data-sold-count]');
        this.remainingEl = this.querySelector('[data-remaining]');
        this.barEl = this.querySelector('[data-progress-bar]');
        this.remainingOne = this.dataset.remainingOne || '__COUNT__ order left';
        this.remainingOther = this.dataset.remainingOther || '__COUNT__ orders left';
        this.accessibilityTemplate = this.dataset.accessibility || '__SOLD__ of ' + this.limit + ' orders sold';
        this.render();
        this.hasRendered = true;
        this.interval = setInterval(() => this.render(), 10000);
      }

      disconnectedCallback() {
        if (this.interval) clearInterval(this.interval);
      }

      mulberry32(seed) {
        return function () {
          let t = (seed += 0x6d2b79f5);
          t = Math.imul(t ^ (t >>> 15), t | 1);
          t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
          return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
        };
      }

      saleTimes(now) {
        const dateKey = now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate();
        if (this._dateKey === dateKey && this._saleTimes) return this._saleTimes;

        const steps = Math.max(1, this.maxSold - this.start);
        const slot = (24 * 60 * 60 * 1000) / steps;
        const rand = this.mulberry32(dateKey >>> 0);
        const times = [];

        for (let i = 0; i < steps; i++) {
          times.push(i * slot + rand() * slot);
        }

        this._dateKey = dateKey;
        this._saleTimes = times;
        return times;
      }

      currentSold() {
        const now = new Date();
        const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
        const elapsed = Math.max(0, now.getTime() - startOfDay);
        const times = this.saleTimes(now);
        let sold = this.start;

        for (let i = 0; i < times.length; i++) {
          if (elapsed >= times[i]) {
            sold += 1;
          } else {
            break;
          }
        }

        return Math.min(sold, this.maxSold);
      }

      render() {
        const sold = this.currentSold();
        const left = this.limit - sold;
        const soldText = String(sold);

        if (this.soldEl && this.soldEl.textContent !== soldText) {
          this.soldEl.textContent = soldText;
          if (this.hasRendered) {
            this.soldEl.classList.remove('is-updated');
            void this.soldEl.offsetWidth;
            this.soldEl.classList.add('is-updated');
          }
        }

        if (this.remainingEl) {
          const template = left === 1 ? this.remainingOne : this.remainingOther;
          this.remainingEl.textContent = template.replace('__COUNT__', String(left));
        }

        if (this.barEl) {
          this.barEl.style.setProperty('--pdl-progress', (sold / this.limit) * 100 + '%');
          this.barEl.setAttribute('aria-valuenow', soldText);
          this.barEl.setAttribute(
            'aria-label',
            this.accessibilityTemplate.replace('__SOLD__', soldText)
          );
        }
      }
    }

    customElements.define('promo-daily-limit', PromoDailyLimit);
  }

  } catch(e) { console.error(e); }
})();
})();
